import React, { PureComponent } from 'react';

import GoogleMap from './googleMap';
import SpanList from './components/spansList';
import PolesList from './components/polesList';
import Drawer from './components/drawer/drawer';
import PoleDetails from './components/poleDetails';
import CardInput from './components/card/cardInput';
import SpanDetails from './components/spanDetails';
import MainMenu2 from './components/mainMenu/mainMenu';
import Form from 'react-bootstrap/Form';

import { FindCenter } from './helpers/spanHelpers';
import { defaultThunderHits } from './sources/thunderStormDefaults';

import searchSpansIcon from './images/distance24.png';
import centerOhlIcon from './images/centerOHL24.png';
import searchPolesIcon from './images/transmitor_search_24.png';
import selectOhlIcon from './images/marked_icon.png';
import markOhlIcon from './images/pencil24.png';
import moreDetailsIcon from './images/more_details.svg';
import searchIcon from './images/search_icon.png';
import zoomSpanIcon from './images/search_01_24.png';
import zoomPhasesIcon from './images/search_03_24.png';
import editMarkerPostionIcon from './images/changeMarkerPosition.svg'
import layersIcon from './images/layers.svg';
import poleBlankIcon from './images/poleBlank.svg';
import flashIcon from './images/flashBlank.svg';
import pruningIcon from './images/chainsaw.svg';
import AddLocationIcon from './images/add_circle_outline-24px.svg';
import PlaneIcon from './images/plane.png';

import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
//import Row from 'react-bootstrap/Row';

import * as MdDV4012Source from './sources/medju/400/DV4012';
import * as Md400DV436Source from './sources/medju/400/DV436';
import * as Md200DV2142Source from './sources/medju/220/DV2142';
import * as Md110DV122BSource from './sources/medju/110/DV122B';
import * as Md110DV1552BSource from './sources/medju/110/DV1552';

// import * as Bg35DV122A1Source from './sources/beograd/35/DV122A1';
// import * as Bg35DV122A2Source from './sources/beograd/35/DV122A2';

import * as Bg110DV104A4Source from './sources/beograd/110/DV104A4';
import * as Bg110DV104A5Source from './sources/beograd/110/DV104A5';
import * as Bg110DV104BSource from './sources/beograd/110/DV104B';
import * as Bg110DV11962Source from './sources/beograd/110/DV11962';
import * as Bg110DV11961Source from './sources/beograd/110/DV11961';
import * as Bg110DV101A3Source from './sources/beograd/110/DV101A3';
import * as Bg110DV101A4Source from './sources/beograd/110/DV101A4';
import * as Bg110DV101B4Source from './sources/beograd/110/DV101B4';
import * as Bg110DV102A1Source from './sources/beograd/110/DV102A1';
import * as Bg110DV1109Source from './sources/beograd/110/DV1109';
import * as Bg110DV102A2Source from './sources/beograd/110/DV102A2';
import * as Bg110DV102B2Source from './sources/beograd/110/DV102B2';
import * as Bg110DV1001Source from './sources/beograd/110/DV1001';
import * as Bg110DV1002Source from './sources/beograd/110/DV1002';
import * as Bg220DV216Source from './sources/beograd/220/DV216';
import * as Bg220DV252Source from './sources/beograd/220/DV252';
import * as Bg220DV254Source from './sources/beograd/220/DV254';
import * as Bg220DV256ASource from './sources/beograd/220/DV256A';
import * as Bg220DV256BSource from './sources/beograd/220/DV256B';
import * as Bg220DV263ASource from './sources/beograd/220/DV263A';
import * as Bg220DV263BSource from './sources/beograd/220/DV263B';
import * as Bg220DV277Source from './sources/beograd/220/DV277';
import * as Bg220DV294ASource from './sources/beograd/220/DV294A';
import * as Bg220DV294BSource from './sources/beograd/220/DV294B';
import * as Bg400DV425Source from './sources/beograd/400/DV425';
import * as Bg400DV453Source from './sources/beograd/400/DV453';
import * as Bg400DV4011Source from './sources/beograd/400/DV4011';


import * as Br35DV122A3Source from './sources/bor/35/DV122A3';
import * as Br35DV122A4Source from './sources/bor/35/DV122A4';
import * as Br35DV122A5Source from './sources/bor/35/DV122A5';
import * as Br35DV1212Source from './sources/bor/35/DV1212';

import * as Br110DV150Source from './sources/bor/110/DV150';
import * as Br110DV1150Source from './sources/bor/110/DV1150';
import * as Br110DV1157Source from './sources/bor/110/DV1157';
import * as Br110DV1165Source from './sources/bor/110/DV1165';
import * as Br110DV1166Source from './sources/bor/110/DV1166';
import * as Br110DV1168Source from './sources/bor/110/DV1168';
import * as Br110DV1186Source from './sources/bor/110/DV1186';
import * as Br110DV1204Source from './sources/bor/110/DV1204';
import * as Br110DV1228ASource from './sources/bor/110/DV1228A';
import * as Br110DV1228BSource from './sources/bor/110/DV1228B';
import * as Br110DV1229ASource from './sources/bor/110/DV1229A';
import * as Br110DV1229BSource from './sources/bor/110/DV1229B';
import * as Br110DV1230Source from './sources/bor/110/DV1230';
import * as Br110DV1241Source from './sources/bor/110/DV1241';
import * as Br110DV1281Source from './sources/bor/110/DV1281';
import * as Br110DV1282Source from './sources/bor/110/DV1282';
import * as Br110DV1283Source from './sources/bor/110/DV1283';
//import * as DV1441Source from './sources/bor/DV1441';
import * as Br110DV1471Source from './sources/bor/110/DV1471';
import * as Br110DV1472Source from './sources/bor/110/DV1472';
import * as Br110DV1481Source from './sources/bor/110/DV1481';
import * as Br110DV1482Source from './sources/bor/110/DV1482';
//import * as Br110DV1483Source from './sources/bor/110/DV1483';

// import * as Br400DV459Source from './sources/bor/400/DV459';
import * as Br400DV457Source from './sources/bor/400/DV457';

import * as Vl110DV106A2Source from './sources/valjevo/110/DV106A2';
import * as Vl110DV106b1Source from './sources/valjevo/110/DV106B1';
import * as Vl110DV106b2Source from './sources/valjevo/110/DV106B2';
import * as Vl220DV106b3Source from './sources/valjevo/110/DV106B3';
import * as Vl220DV2091Source from './sources/valjevo/220/DV2091';
import * as Vl220DV2131Source from './sources/valjevo/220/DV2131'

import * as Ns220DV2171Source from './sources/noviSad/220/DV2171';
import * as Ns220DV275Source from './sources/noviSad/220/DV275';

import * as Ns400DV4061Source from './sources/noviSad/400/DV4061';
import * as Ns400DV450Source from './sources/noviSad/400/DV450';
import * as Ns400DV444Source from './sources/noviSad/400/DV444';

import * as Ks400DV4231Source from './sources/krusevac/400/DV4231'
import * as Ks400DV4232Source from './sources/krusevac/400/DV4232'

import * as I110DV149Source from './sources/inter/110/DV149Inter';
import * as I220DV266Source from './sources/inter/220/DV266';
import * as I220DV2061Source from './sources/inter/220/DV2061';
import * as I400DV404Source from './sources/inter/400/DV404';
import * as I400DV405Source from './sources/inter/400/DV405';
import * as I400DV454Source from './sources/inter/400/DV454';
import * as I400DV455Source from './sources/inter/400/DV455';
//import * as I400DV462Source from './sources/inter/400/DV462';
import * as I400DV4093Source from './sources/inter/400/DV4093';

import * as DV204Source from './sources/medju/220/DV204';

//import * as DV402Source from './sources/bor/400/DV402';
import * as DV458Source from './sources/bor/400/DV458';

import * as Ks110DV1154Source from './sources/krusevac/110/DV1154';
//import * as Ks1100DV1141Source from './sources/krusevac/110/DV1141';
import * as Ks220DV2141Source from './sources/krusevac/220/DV2141';
import * as Ks220DV226Source from './sources/krusevac/220/DV226';

//import * as DV122BSource from './sources/bor/122B';
//import * as DV403Source from './sources/medju/400/DV403';


const zoomBorder1 = 8;
const zoomBorder2 = 15;
const zoomBorder3 = 17;

const ohlSearchStyle = {
    position: 'fixed',
    float: 'left',
    width: '20%',
    height: '100%',
    left: 0,
    overflow: 'auto'
}

const googleMapStyle = {
    position: 'fixed',
    width: '80%',
    top: 0,
    left: '20%',
    right: '15%',
    height: '100%'
}

const ohlSearchStyle2 = {
    position: 'fixed',
    width: '300px',
    top: 0,
    left: '20%',
    right: '15%',
    height: '100%'
}


const regionList = [
    { name: 'Beograd', code: 'BGD' },
    { name: 'Bor', code: 'BR' },
    { name: 'Kruševac', code: 'KS' },
    { name: 'Novi Sad', code: 'NS' },
    //{name: 'Obilić', code: 'OB'},
    //{name: 'Užice', code: 'UE'},
    { name: 'Valjevo', code: 'VA' },
    { name: 'Between Regions', code: 'BET' },
    { name: 'Interconectiv', code: 'INTER' },
]


let thunder;

const thunderBorders = { minLat: 44.562951, maxLat: 45.001513, minLng: 20.131788, maxLng: 20.924780 }; //beograd
///{minLat: 45.004437, maxLat: 45.138021, minLng: 20.020993, maxLng: 20.237208} ///indjija
///{minLat: 44.562951, maxLat: 45.001513, minLng: 20.131788, maxLng: 20.924780}; //beograd
//{minLat: 44.204194, maxLat: 45.254264, minLng: 20.491741, maxLng: 21.009175};//{minLat: 44.174194, maxLat: 45.284264, minLng: 19.491741, maxLng: 21.429175};

export class GoogleMapContainer extends PureComponent {

    //regionList = [];

    constructor(props) {
        super(props);

        this.state = {
            filterText: [],
            ohls: [],
            checkedOhls: [],
            ohlSegments: [],
            selectedSpansList: [],
            selectedPolesList: [],
            selectedObject: null,
            zoom: 10,
            zoomLevel: 0,
            mapCenter: null,
            showDividedPoles: true,
            showDividedSpans: true,
            dividesSpansColor: '#ffff00',

            showOutageLayer: true,
            showUndergrounObjectsLayer: true,
            showPruningLayer: true,

            showPortalsAlways: true,
            showPortalsOnlyForSelectedOHL: true,
            showCountryBorder: true,
            showPhaseCross: true,
            showStations: true,
            showPortalAsDot: true,
            showHealthIndexes: true,
            showSuspensionPoles: true,
            showTensionPoles: true,
            showUndergroundObjects: true,

            showPortalIcons: true, /// postaviti cusstom ikonicu koja je okrenuta na dole
            showThirdLevel: true,
            mapBounds: null,
            map: null,
            checkAll: true,

            selectedPlace: null,
            selectedPlaceName: null,
            showingInfoWindow: false,
            infoWindowPosition: {},
            activeMarker: {},
            ohlSource: {},
            selectedOHLs: [],
            showLargeIcons: false,

            poleEdited: { name: '', lat: 0, lng: 0 },

            showThunderStormEffects: true,
            showAllThunderHits: true,
            showAffectedOhlSections: true,
            simulateThunderStorm: false,
            showOhlThunderHitIcons: true,
            showThunderMap: true,
            thunderStrikesList: defaultThunderHits.thunderHits,
            ohlThunderStrikesList: defaultThunderHits.ohlHits, ////[]
            affectedOhlRegions: defaultThunderHits.regions, ////[]
            thundersRecived: 0,

            showPruningIcons: true,
            showPruningAreas: true,
            showPruningParcels: true,
            showAllPrunings: true,
            isOhlListEdited: false
        };
    }



    componentDidMount() {

        const ohlList = [
            // ////Beograd
            //Bg35DV122A1Source.OHL, // 3  //primer za nepostojece koordinate
            // // //Bg35DV122A2Source.OHL, // 3 //primer za nepostojece koordinate
            Bg110DV101A3Source.OHL,// 3 sections example
            Bg110DV101A4Source.OHL,// 3 sections example
            Bg110DV101B4Source.OHL, // 3 sections example
            Bg110DV102A1Source.OHL, // 3 sections example
            Bg110DV102A2Source.OHL, //dvostruki
            Bg110DV102B2Source.OHL, //dvostruki
            Bg110DV104A4Source.OHL, //3 ?
            Bg110DV104A5Source.OHL, //3 ?
            Bg110DV104BSource.OHL, //3 ?
            Bg110DV1001Source.OHL,
            Bg110DV1002Source.OHL, //1
            Bg110DV1109Source.OHL, //1
            Bg110DV11961Source.OHL, //2 ////nije najbolji primer za deljene raspone
            Bg110DV11962Source.OHL, //2 ///nije najbolji primer za deljene raspone
            Bg220DV216Source.OHL, //1
            Bg220DV252Source.OHL, //1
            Bg220DV254Source.OHL, //1
            Bg220DV256ASource.OHL, //2 ////nije najbolji primer za deljene raspone (identicni dalekovod sa DV256B)
            Bg220DV256BSource.OHL, //2 ////nije najbolji primer za deljene raspone (identicni dalekovod sa DV256A)
            Bg220DV263ASource.OHL, //2  ////nije najbolji primer za deljene raspone (identicni dalekovod sa DV263B)
            Bg220DV263BSource.OHL, //2 ////nije najbolji primer za deljene raspone (identicni dalekovod sa DV263A)
            Bg220DV277Source.OHL, //1
            Bg220DV294ASource.OHL, //dvostruki
            Bg220DV294BSource.OHL, //dvostruki

            //// BOR 35
            Br35DV122A3Source.OHL, //2 //122B
            Br35DV122A4Source.OHL, //2 //122A3, 122B
            Br35DV122A5Source.OHL, //2
            Br35DV1212Source.OHL,  //1
            Md200DV2142Source.OHL,
            Md110DV122BSource.OHL,  //3 //prostire se kroz dva pogona, prate ga dalekovodi 122A1-A5
            Md110DV1552BSource.OHL,
            DV204Source.OHL,  //1

            // DV402Source.OHL,
            Bg400DV425Source.OHL, //1
            Bg400DV453Source.OHL, //1
            Br400DV457Source.OHL, //1
            Bg400DV4011Source.OHL, //1
            DV458Source.OHL, //1
            // DV459Source.OHL,
            // //DV1001

            Ks110DV1154Source.OHL,
            //Ks1100DV1141Source.OHL,
            Ks220DV2141Source.OHL,
            Ks220DV226Source.OHL,
            Vl220DV2091Source.OHL, //1
            MdDV4012Source.OHL, //1 ////preplitaji
            // //DV403Source.OHL,
            Ns400DV444Source.OHL,
            Ns400DV450Source.OHL,
            Vl220DV2131Source.OHL, //1

            Ns220DV2171Source.OHL, //1
            Ns220DV275Source.OHL,
            Ns400DV4061Source.OHL, //1
            I400DV404Source.OHL,
            I400DV405Source.OHL,
            I400DV454Source.OHL,
            I400DV455Source.OHL,
            //I400DV462Source.OHL, najjuzniji, za test zooma
            I400DV4093Source.OHL,
            I220DV2061Source.OHL,
            Vl110DV106b1Source.OHL, //2
            Vl110DV106b2Source.OHL, //3 //106B1, 106B3
            Vl220DV106b3Source.OHL, //3 //106B1, 106B2
            Vl110DV106A2Source.OHL, //3//106B2, 106B3


            I110DV149Source.OHL, //dvostruki (primer)
            Br110DV150Source.OHL,
            Br110DV1150Source.OHL,
            Br110DV1157Source.OHL, //dvostruki (primer)
            Br110DV1165Source.OHL,
            Br110DV1166Source.OHL,
            Br110DV1168Source.OHL,
            Br110DV1186Source.OHL,
            Br110DV1204Source.OHL,
            I220DV266Source.OHL,
            Md400DV436Source.OHL,
            Ks400DV4231Source.OHL,
            Ks400DV4232Source.OHL,
            Br110DV1228ASource.OHL,
            Br110DV1228BSource.OHL,
            Br110DV1229ASource.OHL,
            Br110DV1229BSource.OHL,
            Br110DV1230Source.OHL,
            Br110DV1241Source.OHL,
            Br110DV1281Source.OHL, ////preplitaji
            Br110DV1282Source.OHL,
            Br110DV1283Source.OHL,
            // //DV1441Source.OHL,
            Br110DV1471Source.OHL,
            Br110DV1472Source.OHL,
            Br110DV1481Source.OHL,
            Br110DV1482Source.OHL,


            //DV1483Source.OHL,// 3 sections example

        ];

        this.setState({
            ohls: ohlList,
            checkedOhls: ohlList,
            selectedOHLs: [],

            debljina35: 3,
            debljna110: 5,
            debljina220: 7,
            deblljina400: 9,
            zoomLevel: this.getZoomLevel(this.state.zoom),
            color35: ' #00ffcc',
            color110: '#00ff00',
            color220: '#0033cc',
            color400: '#ff0000',
            showDetails: null
        })
    }

    setMap = (currentMap) => { this.setState({ map: currentMap }); }


    onZoomChanged = (props, map) => {
        this.setState({
            zoom: map.zoom,
            zoomLevel: this.getZoomLevel(map.zoom)
        });
    }

    getZoomLevel = (zoom) => {
        let result =
            zoom > zoomBorder1 && zoom <= zoomBorder2 ? 1
                : zoom > zoomBorder2 && zoom <= zoomBorder3 ? 2
                    : zoom > zoomBorder3 ? 3 : 0;

        return result;
    };

    onZoomFirstLevel = (mapCenter) => {
        if (mapCenter) this.zoomObject(mapCenter, zoomBorder1 + 1);
    }

    onZoomSecondLevel = (mapCenter) => {
        if (mapCenter) this.zoomObject(mapCenter, zoomBorder2 + 1);
    }

    onZoomThirdLevel = (mapCenter) => {
        if (mapCenter) this.zoomObject(mapCenter, zoomBorder3 + 1);
    }

    onZoomFirstLevelAndCloseInfowindow = (mapCenter) => {
        if (mapCenter) this.zoomObject(mapCenter, zoomBorder1 + 1);
        if (this.state.showingInfoWindow) this.setState({ showingInfoWindow: false });
    }

    onZoomSecondLevelAndCloseInfowindow = (mapCenter) => {
        if (mapCenter) this.zoomObject(mapCenter, zoomBorder2 + 1);
        if (this.state.showingInfoWindow) this.setState({ showingInfoWindow: false });
    }

    onZoomThirdLevelAndCloseInfowindow = (mapCenter) => {
        if (mapCenter) this.zoomObject(mapCenter, zoomBorder3 + 1);
        if (this.state.showingInfoWindow) this.setState({ showingInfoWindow: false });
    }

    onZoomSpan = (spanName, path, level) => {
        let position = FindCenter(path[0], path[1]);

        if (level === 2) this.onZoomSecondLevel(position);
        else if (level === 3) this.onZoomThirdLevel(position);

        this.onSpanFromListClick(this.state.selectedOHLs[0].name, spanName);
    }

    onZoomPole = (index, position, level) => {
        if (level === 2) this.onZoomSecondLevel(position);
        else if (level === 3) this.onZoomThirdLevel(position)

        this.onPoleClick(this.state.selectedOHLs[0].name, index);
    }


    zoomObject = (mapCenter, zoom) => {
        const map = this.state.map;
        if (mapCenter && zoom) {
            map.setZoom(zoom);
            this.setState({
                zoomLevel: this.getZoomLevel(zoom),
                mapCenter: mapCenter
            })
        }
    }


    setOhlSelected = (ohlList) => {
        if (!this.areListSame(this.state.selectedOHLs, ohlList)) {
            this.reseteSelectLists();
        }

        this.setState({
            selectedOHLs: ohlList
        });
    }

    areListSame = (list1, list2) => {

        if ((!list1 || !list2) && (list1 || list2)) return false;
        if (list1.length !== list2.length) return false;
        if (list1[0].name !== list2[0].name) return false
        return true
    }

    reseteSelectLists = () => {
        this.setState({
            selectedPolesList: [],
            selectedSpansList: [],
            selectedObject: null,
            showDetails: null
        });
    }

    clearMap = () => {
        this.setState({
            selectedOHLs: [],
            selectedPolesList: [],
            selectedSpansList: [],
            showDetails: null,
            showingInfoWindow: false
        });
    }

    onShowSpans = () => {
        let selectedSpans = []
        if (this.state.selectedOHLs.length === 1) {
            selectedSpans = this.state.ohls.filter(ohl => ohl.name === this.state.selectedOHLs[0].name)[0].rasponi;
        }

        this.setState({
            selectedSpansList: selectedSpans,
            selectedPolesList: null,
            showDetails: 'ohlSpans'
        });
    }

    onShowPoles = () => {
        let selectedPoles = []
        if (this.state.selectedOHLs.length === 1) {
            selectedPoles = this.state.ohls.filter(ohl => ohl.name === this.state.selectedOHLs[0].name)[0].stubovi;
        }

        this.setState({
            selectedPolesList: selectedPoles,
            selectedSpansList: null,
            showDetails: 'ohlPoles'
        });
    }

    centerOHLByName = (ohlName) => {

        let ohl = this.findOhlFromList(ohlName);
        if (ohl) {
            let path = ohl.stubovi;
            if (path && path.length > 0) {

                let latMax = path[0].lat;
                let latMin = path[0].lat;
                let lngMax = path[0].lng;
                let lngMin = path[0].lng;

                path.forEach(pole => {
                    if (pole.lat > latMax) latMax = pole.lat;
                    if (pole.lat < latMin) latMin = pole.lat;
                    if (pole.lng > lngMax) lngMax = pole.lng;
                    if (pole.lng < lngMin) lngMin = pole.lng;
                });

                let map = this.state.map;
                map.fitBounds({ north: latMax, east: lngMax, south: latMin, west: lngMin });
                this.onOhlClick(ohl);
            }
        }
    }

    focusAllOHLs = () => {

        if (this.state.checkedOhls && this.state.checkedOhls.length > 0) {
            let minLat = 100;
            let maxLat = 0;
            let minLng = 100;
            let maxLng = 0;

            this.state.checkedOhls.forEach(ohl => {
                ohl.stubovi.forEach(pole => {
                    if (pole.lat && pole.lat > 0) {
                        if (pole.lat < minLat) minLat = pole.lat;
                        if (pole.lat > maxLat) maxLat = pole.lat;
                    }
                    if (pole.lng && pole.lng > 0) {
                        if (pole.lng < minLng) minLng = pole.lng;
                        if (pole.lng > maxLng) maxLng = pole.lng;
                    }
                });
            });

            let map = this.state.map;
            map.fitBounds({ north: maxLat, east: maxLng, south: minLat, west: minLng });
        }
    }

    focusAllOHLs2 = (ohlList) => {

        if (ohlList && ohlList.length > 0) {
            let minLat = 100;
            let maxLat = 0;
            let minLng = 100;
            let maxLng = 0;

            ohlList.forEach(ohl => {
                ohl.poles.forEach(pole => {
                    if (pole.lat && pole.lat > 0) {
                        if (pole.lat < minLat) minLat = pole.lat;
                        if (pole.lat > maxLat) maxLat = pole.lat;
                    }
                    if (pole.lng && pole.lng > 0) {
                        if (pole.lng < minLng) minLng = pole.lng;
                        if (pole.lng > maxLng) maxLng = pole.lng;
                    }
                });
            });

            let map = this.state.map;
            map.fitBounds({ north: maxLat, east: maxLng, south: minLat, west: minLng });
        }
    }


    findOhlFromList = ohlName => {
        return this.state.ohls.find(ohl => ohl.name === ohlName);
    }

    onToogleOhlChecked = (selectedOhl, isChecked) => {

        if (isChecked) {
            let checkedOhl = this.state.ohls.find(ohl => ohl.name === selectedOhl);
            if (checkedOhl) {
                let newCheckedOhlList = this.state.checkedOhls.concat(checkedOhl);
                this.setState({
                    checkedOhls: newCheckedOhlList
                });
            }
        }
        else {
            this.setState({
                checkedOhls: this.state.checkedOhls.filter(ohl => ohl.name !== selectedOhl),
                selectedOHLs: this.state.selectedOHLs.filter(ohl => ohl.name !== selectedOhl),
            });
        }

        this.setState({
            showingInfoWindow: false
        })
    }

    onToogleOhlsChecked = (checkedOhlsList, isChecked) => {
        if (isChecked) {
            let newlyCheckedList = [];

            checkedOhlsList.forEach(selectedOhl => {
                let checkedOhl = this.state.ohls.find(ohl => ohl.name === selectedOhl);
                let isAlreadyChecked = this.state.checkedOhls.find(ohl => ohl.name === selectedOhl);
                if (checkedOhl && !isAlreadyChecked) {
                    newlyCheckedList.push(checkedOhl);
                }
            });

            this.setState({
                checkedOhls: [...this.state.checkedOhls].concat(newlyCheckedList)
            })
        }
        else {
            let checkedOhlsNew = [...this.state.checkedOhls];
            let selectedOhlsNew = [...this.state.selectedOHLs];
            checkedOhlsList.forEach(ohl => {
                let index = checkedOhlsNew.map(ohl => ohl.name).indexOf(ohl);
                if (index !== -1) {
                    checkedOhlsNew.splice(index, 1)
                };

                let indexSelected = selectedOhlsNew.map(ohl => ohl.name).indexOf(ohl);
                if (indexSelected !== -1) {
                    selectedOhlsNew.splice(indexSelected, 1)
                };
            });

            this.setState({
                checkedOhls: checkedOhlsNew,
                selectedOHLs: selectedOhlsNew
            });
        }

        this.setState({
            showingInfoWindow: false
        })
    }

    onToogleCheckAll = (e) => {

        this.setState((previousState) => ({
            checkAll: !previousState.checkAll,
            selectedSpansList: previousState.checkAll === true ? previousState.selectedSpansList : [],
            selectedPolesList: previousState.checkAll === true ? previousState.selectedPolesList : [],
        }));

        this.onToogleOhlsChecked(this.state.ohls.map(ohl => ohl.name), e.target.checked);
    }

    toogleState = (props) => {

        this.setState((previousState) => ({
            [props]: !previousState[props]
        }));
    }

    filterChange = (e) => {
        setTimeout(2000);
        this.setState({
            filterText: e.target.value,
            showingInfoWindow: false
        });
    }

    toogleSimulateThunderStorm = () => {
        if (this.state.simulateThunderStorm) {
            clearInterval(thunder);
            this.setState({
                simulateThunderStorm: false
            })
        }
        else {
            thunder = setInterval(this.thunderHit, 1000);
            this.setState({
                simulateThunderStorm: true
            })
        }
    }

    thunderHit = () => {

        // let p1 = performance.now();
        const shift = 0.001 ///0.003;
        const thunderLat = this.randomNumberBetween(thunderBorders.minLat, thunderBorders.maxLat);
        const thunderLng = this.randomNumberBetween(thunderBorders.minLng, thunderBorders.maxLng);

        let ohlThunderStrikesList = [];
        let thunderStrikesList = [];
        let possiblyAffected = [];
        //let c = this.state.ohls;

        this.state.ohls.forEach(ohl => {
            ohl.stubovi.forEach((pole, index) => {

                if (pole.lat + shift > thunderLat
                    && pole.lat - shift < thunderLat
                    && pole.lng + shift > thunderLng
                    && pole.lng - shift < thunderLng) {
                    possiblyAffected = possiblyAffected.concat(pole);

                    let affectedPoles = null;

                    if (!ohlThunderStrikesList.some(strike => strike.lat === thunderLat && strike.lng === thunderLng)) {

                        const today = new Date();
                        const time = today.getDate() + '/' + today.getMonth() + '/' + today.getFullYear() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
                        const isOutage = Math.random() < 0.75 ? false : true;

                        let affectedLenght = index;

                        let numberOfPoles = ohl.stubovi.length;
                        let ohlPoles = [...ohl.stubovi];

                        if (index >= numberOfPoles / 2) {
                            affectedPoles = { ohl: ohl.name, poles: ohlPoles.splice(index, numberOfPoles) }
                            affectedLenght = numberOfPoles - index;
                        }
                        else {
                            affectedPoles = { ohl: ohl.name, poles: ohlPoles.splice(0, index + 1), isOutage: isOutage }
                        }

                        ohlThunderStrikesList.push(
                            {
                                isOutage: isOutage,
                                position: { lat: thunderLat, lng: thunderLng },
                                ohl: ohl.name,
                                pole: pole.name,
                                time: time,
                                poleItemIndex: pole.index,
                                stationName: ohl.stanice && ohl.stanice.length > 0 && ohl.stanice[0].name ? ohl.stanice[0].name : '/',
                                length: affectedLenght * 0.35
                            });

                        this.setState((previousState) => ({
                            affectedOhlRegions: previousState.affectedOhlRegions.concat(affectedPoles)
                        }))

                    }
                }
                else {
                    if (!thunderStrikesList.some(strike => strike.lat === thunderLat && strike.lng === thunderLng)) {
                        thunderStrikesList = thunderStrikesList.concat({ lat: thunderLat, lng: thunderLng });
                    }
                }
            });
        });

        this.setState((previousState) => ({
            thunderStrikesList: previousState.thunderStrikesList.concat({ lat: thunderLat, lng: thunderLng }),
            ohlThunderStrikesList: previousState.ohlThunderStrikesList.concat(ohlThunderStrikesList),
            thundersRecived: previousState.thundersRecived + 1

        }))
    }

    doesThunderHitOHL = (pole, shift, thunder) => {
        let thunderHit = false;

        if (pole.lat + shift > thunder.lat
            && pole.lat - shift < thunder.lat
            && pole.lng + shift > thunder.lng
            && pole.lng - shift < thunder.lng) {
            thunderHit = true
        }

        return thunderHit;
    }

    randomNumberBetween = (minValue, maxValue) => this.roundDecimal((Math.random() * (maxValue - minValue) + minValue), 5);

    roundDecimal = (value, decimals) => Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);

    onOhlClick = (props, map, e) => {

        if (props.stubovi && props.stubovi.length > 0) {
            let position = this.getCurrentPosition(e);
            if (!position) {
                position = props.stubovi[Math.round(props.stubovi.length / 2)];
            }
            let ohlElement =
                <span>
                    <span style={{ 'lineHeight': '20px' }} >
                        <b><u>OHL</u></b> <br />
                        <b>Name:</b> {props.name ? props.name : 'Unknown'} <br />
                        <b>Voltage: </b> {props.voltage ? props.voltage : 'N/A'} kV <br />
                        <b>Length: </b> {Math.round(props.stubovi.length * 0.35)} km <br />
                        <b>Poles: </b > {props.stubovi.length} <br />
                        {/* <span onClick={this.onShowSpans} style={{marginRight: '25px', marginTop: '15px', cursorcursor: 'pointer'}} > <img src={searchSpansIcon} title='Search Spans' alt='Search Spans' /> </span>
                        <span onClick={this.onShowPoles} style={{marginRight: '25px', marginTop: '100px', cursor: 'pointer'}} > <img src={searchPolesIcon} title='Search Poles' alt='Search Poles' /> </span> */}
                        {/* <span onClick={() => this.centerOHLByName(props.name)} style={{marginRight: '25px', 'marginTop': '15px', cursor: 'pointer'}} ><img src={centerOhlIcon} title='Center OHL' alt='Center OHL' /> </span> */}
                    </span>
                    <span>
                        <span
                            onClick={() => this.onZoomSecondLevelAndCloseInfowindow(position)}
                            style={{ marginRight: '25px', 'marginTop': '15px', cursor: 'pointer' }} >
                            <img src={zoomSpanIcon} height='25' width='25' title='Zoom to span level' alt='Zoom to span level' />
                        </span>
                        <span
                            onClick={() => this.onZoomThirdLevelAndCloseInfowindow(position)}
                            style={{ marginRight: '25px', 'marginTop': '15px', cursor: 'pointer' }} >
                            <img src={zoomPhasesIcon} height='25' width='25' title='Zoom to phase level' alt='Zoom to phase level' />
                        </span>
                        <span
                            onClick={() => this.centerOHLByName(props.name)}
                            style={{ marginRight: '25px', 'marginTop': '15px', cursor: 'pointer' }} >
                            <img src={centerOhlIcon} title='Center OHL' alt='Center OHL' />
                        </span>
                        <span onClick={this.onShowSpans} style={{ marginRight: '25px', marginTop: '150px', cursor: 'pointer' }} > <img src={searchSpansIcon} title='Search Spans' alt='Search Spans' /> </span>
                        <span onClick={this.onShowPoles} style={{ marginRight: '25px', marginTop: '100px', cursor: 'pointer' }} > <img src={searchPolesIcon} title='Search Poles' alt='Search Poles' /> </span>
                    </span>
                </span>

            this.setState({
                selectedPlace: ohlElement,
                selectedPlaceName: props.name,
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: position,
                //selectedOHLs: [{name: props.name, poles: this.props.ohlList.filter(ohl => ohl.name === props.name)[0].stubovi}]
            })

            this.setOhlSelected([{ name: props.name, poles: this.state.ohls.filter(ohl => ohl.name === props.name)[0].stubovi }])
        }
    }

    onSegmentClick = (props, r, e) => {

        if (props.path && props.path.length > 0) {

            const position = this.getCurrentPosition(e);

            let element;
            let selectedOHL;
            let selectedOhlsList = [];

            props.ohls.forEach((ohlName) => {
                selectedOHL = this.state.ohls.filter(o => o.name === ohlName)[0]
                selectedOhlsList.push({ name: ohlName, poles: selectedOHL.stubovi ? selectedOHL.stubovi : selectedOHL.poles })
            })

            if (props.ohls.length < 2) {
                element =
                    <div style={{ 'lineHeight': '20px' }}>
                        <u><b>OHL</b></u>
                        <br /> <b>Name:</b> {selectedOHL.name ? selectedOHL.name : 'Unknown'} <br />
                        <b>Voltage: </b> {selectedOHL.voltage ? selectedOHL.voltage : 'N/A'} kV <br />
                        <b>Length: </b> {Math.round(selectedOHL.stubovi.length * 0.35)} <br />
                        <b>Pole nr.: </b> {selectedOHL.stubovi.length} <br />
                        <span onClick={this.onShowSpans} style={{ marginRight: '25px', marginTop: '10px', cursor: 'pointer' }}><img src={searchSpansIcon} title='Search Spans' alt='Search Spans' /> </span>
                        <span onClick={this.onShowPoles} style={{ marginRight: '25px', marginTop: '10px', cursor: 'pointer' }} > <img src={searchPolesIcon} title='Search Poles' alt='Search Poles' /> </span>
                        <span onClick={() => this.centerOHLByName(selectedOHL.name)} style={{ marginRight: '25px', marginTop: '10px', cursor: 'pointer' }}><img src={centerOhlIcon} title='Center OHL' alt='Center OHL' /></span>
                    </div>
            }
            else {
                element =
                    <div>
                        <b><u> Divided OHL Segment </u></b> <br />
                        {props.ohls.map((ohlName, index) =>
                            <div key={index}> <b>OHL(<i>{index + 1}</i>) : </b> {ohlName}
                                <span onClick={() => this.markOhl(ohlName)} style={{ marginLeft: '10px', cursor: 'pointer' }} > <img src={markOhlIcon} title='Mark OHL' alt='Mark OHL' /> </span>
                                <span onClick={() => this.onOhlClick(this.state.ohls.filter(ohl => ohl.name === ohlName)[0])} style={{ marginLeft: '10px', cursor: 'pointer' }} > <img src={selectOhlIcon} title='Select OHL' alt='Select OHL' /> </span>
                            </div>)
                        }
                    </div>
            }

            this.setState({
                selectedPlace: element,
                selectedPlaceName: 'OhlSegment',
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: position,
                //selectedOHLs: selectedOhlsList
            })

            this.setOhlSelected(selectedOhlsList);
        }
    }

    onPortalClick = (props, marker) => {
        this.setState({
            selectedPlace:
                <div style={{ 'lineHeight': '20px' }}>
                    <b><u>Portal</u></b>  <br />
                    <b>OHL: </b> {props.ohlName} <br />
                    <b>Name: </b> {props.poleName} <br />
                    <b>Index: </b> {props.poleItemIndex} <br />
                    <span onClick={() => this.onShowPoleDetails(props.ohlName, props.poleName, props.poleItemIndex, props.position ? props.position.lat : null, props.position ? props.position.lng : null, null, true)}
                        style={{ width: '20px', height: '20px', marginRight: '25px', marginTop: '10px', cursor: 'pointer' }} >
                        <img src={moreDetailsIcon} title='Pole details' alt='Pole Details' width='25px' height='25px' />
                    </span>
                    <span onClick={() => this.onShowPoleDetails(props.ohlName, props.poleName, props.poleItemIndex, props.position ? props.position.lat : null, props.position ? props.position.lng : null, null, true)}
                        style={{ width: '20px', height: '20px', marginRight: '25px', marginTop: '10px', cursor: 'pointer' }} >

                        <a href="http://3d.mapsoft.co.rs/electricalNetwork/" target="_blank" > <img src={PlaneIcon} title='Point of cloud view' alt='Point of cloud view' width='25px' height='25px' /></a>
                    </span>
                </div>,
            activeMarker: marker,
            showingInfoWindow: true
        })
    };


    onEditPolePosition = (currentPosition) => {
        this.setState({
            editType: 'pole',
            editObject: { currentPosition: currentPosition },
            showingInfoWindow: false
        })
    }

    onPoleClick = (ohlName, poleItemIndex, lat, lng, sys) => {
        const ohl = this.findOhlFromList(ohlName);

        if (ohl && ohl.stubovi) {
            const pole = ohl.stubovi.find(pole => pole.index === poleItemIndex);
            const position = { lat: lat, lng: lng };

            if (pole) {

                const poleElement =
                    <div style={{ 'lineHeight': '20px' }}>
                        <b><u>Pole</u></b><br />
                        <b>Name: </b> {pole.name} <br />
                        <b>Index: </b> {poleItemIndex} <br />
                        <span onClick={() => this.onShowPoleDetails(ohl.name, pole.name, poleItemIndex, lat, lng, sys, false)}
                            style={{ width: '20px', height: '20px', marginRight: '25px', marginTop: '10px', cursor: 'pointer' }} >
                            <img src={moreDetailsIcon} title='Pole details' alt='Pole Details' width='25px' height='25px' />
                        </span>
                        <span onClick={() => this.onEditPolePosition(position)}
                            style={{ width: '20px', height: '20px', marginRight: '25px', marginTop: '10px', cursor: 'pointer' }} >
                            <img src={editMarkerPostionIcon} title='Edit pole location' alt='EditPoleLocation' width='25px' height='25px' />
                        </span>
                        {/* <span onClick={() => this.onZoomThirdLevel(props.map, {lat: pole.lat, lng: pole.lng})} style={{cursor: 'pointer'}}> <img src={searchIcon} title='Zoom station' alt='Zoom station' /></span> */}
                        {/* <span onClick={() => this.centerOHLByName(ohlName)} style={{marginRight: '25px', marginTop: '15px', cursor: 'pointer'}} ><img src={centerOhlIcon} title='Center OHL' alt='Center OHL' /> </span> */}
                    </div>

                this.setState({
                    selectedPlace: poleElement,
                    selectedPlaceName: pole.name,
                    showingInfoWindow: true,
                    activeMarker: null,
                    infoWindowPosition: position
                })
            }
        }
    };

    getInfowindowsPhaseCrossElement = (path, ohls, spanName, crosses) => {

        let phaseCrossCenter = FindCenter(path[0], path[1])
        return <div style={{ 'lineHeight': '20px' }}>
            <b><u>Phase Cross</u></b> <br />
            {ohls ? ohls.map((ohlName, index) => ohls.length > 1 ? <div key={ohlName + String(index)}><b>OHL({index + 1}):</b> {ohlName} </div> : <div key={ohlName + String(index)}><b>OHL:</b> {ohlName} </div>) : null}
            <b>Span:</b> {spanName} <br />
            {crosses ? <b><u>Crosses: </u> </b> : null}
            {crosses ? crosses.map((p, phaseIndex) => <div key={p.phase + String(phaseIndex)}><b>{p.phase} : </b> {p.position1} -> {p.position2} </div>) : null}
            <span onClick={() => this.onZoomThirdLevel(phaseCrossCenter)} style={{ cursor: 'pointer' }}> <img src={searchIcon} title='Zoom' alt='Zoom' /> </span>
        </div>;
    }

    getInfoWindowUndergroundObjectElement = (props, isSubElement) => {
        let position = FindCenter(props.path[0], props.path[1]);
        let spanDetailsElement = isSubElement ? null :
            <span>
                <div><b>OHL:</b> {props.ohl} </div>
                <div><b>Span:</b> {props.span}</div>
            </span>
        return <div style={{ 'lineHeight': '20px' }}>
            <b><u>Undeline object: </u></b> <br />
            {spanDetailsElement}
            <div><b>Position:</b> Lat:  {Math.round(position.lat * 100) / 100}  Lng:  {Math.round(position.lng * 100) / 100}  </div>
            {props.objects.map((object, index) =>
                <div key={object.name + index}>
                    <b> Name: </b> {object.name} <br />
                    <b>Type: </b> {object.type} <br />
                    <b>Owner: </b> {object.owner} <br />
                    <b><u>Contact </u></b> <br />
                    <b>Responsible Person: </b> {object.responsiblePerson} <br />
                    <b>Contact Number: </b> {object.contact} <br />
                    <b>Email: </b> {object.mail} <br />
                </div>)

                // { name: 'Gas pipe Petrovac 5', type: 'Gas pipe', owner: 'NIS', responsiblePerson: 'Ivan Ignjatovic', contact: '00381 11 256 414', mail: 'IvaIga@nis.rs' }
            }
        </div>;
    }

    getInfoWindowPruningElement = (props) => {
        let position = props.position; //FindCenter(props.path[0], props.path[1]);
        return <div style={{ 'lineHeight': '20px' }}>
            <b><u>Vegetation in span: </u></b> <br />
            <div><b>Position:</b> Lat:  {Math.round(position.lat * 100) / 100}  Lng:  {Math.round(position.lng * 100) / 100}  </div>
            <div><b>OHL:</b> {props.ohl} </div>
            <div><b>Span:</b> {props.span} </div>
            <div><b>Vegitation:</b> {props.vegetationType} </div>
            <div><b>Status:</b> {props.height} </div>
            <div><b>Urgent:</b> {props.isUrgent ? 'Yes' : 'No'} </div>
        </div>;
    }

    onSpanFromListClick = (ohlName, spanName) => {
        //debugger;

        let ohl = this.findOhlFromList(ohlName);
        let undergroundObjectElement = null;
        let phaseCrossesElement = null;
        let pruningElement = null;

        if (ohl && ohl.rasponi) {
            let span = ohl.rasponi.find(span => span.name === spanName);

            if (ohl.undergroundObjects && ohl.undergroundObjects.length > 0) {
                let spanUnderGroundObjects = ohl.undergroundObjects.find(uo => uo.span === spanName)
                if (spanUnderGroundObjects) {
                    undergroundObjectElement = this.getInfoWindowUndergroundObjectElement(spanUnderGroundObjects, true)
                }
            }

            if (ohl.pruningList && ohl.pruningList.length > 0) {

                let pruning = ohl.pruningList.find(uo => uo.name === spanName)
                if (pruning) {
                    pruningElement = this.getInfoWindowPruningElement(pruning)
                }
            }

            if (ohl.phaseCross && ohl.phaseCross.length > 0) {
                let phaseCross = ohl.phaseCross.find(pc => pc.name === spanName)
                if (phaseCross) {
                    //phaseCrossesElement = this.getinf(phaseCross)
                }
            }

            if (span && span.position && span.position.length > 0) {
                let position = FindCenter(span.position[0], span.position[1]);
                let spanElement =
                    <div style={{ 'lineHeight': '20px' }}>
                        <b><u>Span</u></b> <br />
                        <div><b>OHL:</b> {ohlName} </div>
                        <div><b>Name: </b>{spanName} </div>
                        <div><b>Voltage: </b>{ohl.voltage} kV</div>
                    </div>;

                let infowWindowsElement =
                    <span>
                        {spanElement}
                        {undergroundObjectElement}
                        {pruningElement}
                        {phaseCrossesElement}
                        <span
                            onClick={() => this.onZoomThirdLevel(position)}
                            style={{ marginRight: '25px', marginTop: '15px', cursor: 'pointer', 'lineHeight': '20px' }}>
                            <img src={searchIcon} title='Zoom phases' alt='Zoom phases' />
                        </span>
                        <span
                            onClick={() => this.onShowSpanDetails(span.name, ohl.voltage)}
                            style={{ marginRight: '25px', marginTop: '10px', cursor: 'pointer', 'lineHeight': '20px' }} >
                            <img src={moreDetailsIcon} title='Span details' alt='Span Details' style={{ width: '20px', height: '20px' }} />
                        </span>
                        <span
                            onClick={() => this.centerOHLByName(ohlName)}
                            style={{ marginRight: '25px', marginTop: '15px', cursor: 'pointer', 'lineHeight': '20px' }}>
                            <img src={centerOhlIcon} title='Center OHL' alt='Center OHL' />
                        </span>
                    </span>

                this.setState({
                    selectedPlace: infowWindowsElement,
                    selectedPlaceName: spanName,
                    showingInfoWindow: true,
                    activeMarker: null,
                    infoWindowPosition: position
                })
                //}
            }
        }
    }

    onSpanClick = (props, span, e) => {

        const position = this.getCurrentPosition(e);

        let ohl = this.findOhlFromList(props.ohlName);
        let undergroundObjectElement = null;
        let phaseCrossesElement = null;
        let pruningElement = null;
        const spanName = props.name;

        if (ohl && ohl.rasponi) {
            let span = ohl.rasponi.find(span => span.name === spanName);

            if (ohl.undergroundObjects && ohl.undergroundObjects.length > 0) {
                let spanUnderGroundObjects = ohl.undergroundObjects.find(uo => uo.span === spanName)
                if (spanUnderGroundObjects) {
                    undergroundObjectElement = this.getInfoWindowUndergroundObjectElement(spanUnderGroundObjects, true)
                }
            }

            if (ohl.pruningList && ohl.pruningList.length > 0) {

                let pruning = ohl.pruningList.find(uo => uo.name === spanName)
                if (pruning) {
                    pruningElement = this.getInfoWindowPruningElement(pruning)
                }
            }

            if (ohl.phaseCross && ohl.phaseCross.length > 0) {
                let phaseCross = ohl.phaseCross.find(pc => pc.name === spanName)
                if (phaseCross) {
                    //phaseCrossesElement = this.getinf(phaseCross)
                }
            }

            if (span) {
                const firstPoleName = span.name.substring(0, span.name.indexOf('-') - 1);
                let spanElement =
                    <div style={{ 'lineHeight': '20px' }}>
                        <b><u>Span</u></b> <br />
                        <div><b>OHL:</b> {props.ohlName} </div>
                        <div><b>Name: </b>{spanName} </div>
                        <div><b>Voltage: </b>{ohl.voltage} kV</div>
                    </div>;


                this.setState({
                    poleEdited: { 
                        name: firstPoleName + '(1)', 
                        lat: position.lat, 
                        lng: position.lng, 
                        ohlName: props.ohlName, 
                        spanName: span.name 
                    }
                })

                let infowWindowsElement =
                    <span>
                        {spanElement}
                        {undergroundObjectElement}
                        {pruningElement}
                        {phaseCrossesElement}
                        <span
                            onClick={() => this.onZoomThirdLevel(position)}
                            style={{ marginRight: '25px', marginTop: '15px', cursor: 'pointer', 'lineHeight': '20px' }}>
                            <img src={searchIcon} title='Zoom phases' alt='Zoom phases' />
                        </span>
                        <span
                            onClick={() => this.onShowSpanDetails(span.name, ohl.voltage)}
                            style={{ marginRight: '25px', marginTop: '10px', cursor: 'pointer', 'lineHeight': '20px' }} >
                            <img src={moreDetailsIcon} title='Span details' alt='Span Details' style={{ width: '20px', height: '20px' }} />
                        </span>
                        <span
                            onClick={() => this.centerOHLByName(props.ohlName)}
                            style={{ marginRight: '25px', marginTop: '15px', cursor: 'pointer', 'lineHeight': '20px' }}>
                            <img src={centerOhlIcon} title='Center OHL' alt='Center OHL' />
                        </span>
                        <span
                            onClick={() => this.addPoleToSpan(props.ohlName, spanName, position)}
                            style={{ marginRight: '25px', marginTop: '15px', cursor: 'pointer', 'lineHeight': '20px' }}>
                            <img src={AddLocationIcon} title='Add Pylon' alt='Add Pylon' />
                        </span>

                    </span>

                this.setState({
                    selectedPlace: infowWindowsElement,
                    selectedPlaceName: spanName,
                    showingInfoWindow: true,
                    activeMarker: null,
                    infoWindowPosition: position
                })
                //}
            }
        }
    }

    addPoleToSpan = (ohlName, spanName, position) => {
        //debugger;




        // const infowWindowsElement =
        //     <div style={{ 'lineHeight': '20px' }}>
        //         <Form>
        //             <Form.Group controlId="formGroupName">
        //                 <Form.Control type="text" placeholder="Pole Name" id='name' controlId='name' value={this.state.poleEdited.name} onChange={this.changePole} />
        //             </Form.Group>
        //             <Form.Group controlId="formGroupLatitude">
        //                 <Form.Control type="text" value={this.state.poleEdited.lat} id='lat' controlId='lat' onChange={this.changePole} placeholder="Latitude" />
        //             </Form.Group>
        //             <Form.Group controlId="formGroupLongitude">
        //                 <Form.Control type="text" value={this.state.poleEdited.lng} id='lng' controlId='lng' onChange={this.changePole} placeholder="Longitude" />
        //             </Form.Group>
        //         </Form>
        //         <span /*onClick={() => this.onZoomThirdLevel(props.map, props.position)}*/ style={{ cursor: 'pointer' }}>
        //             {/* <img src={CheckIcon} title='Add Pole' alt='Add Pole' /> */}
        //             <CheckIcon title='Add Pole' alt='AddPole' title='Add pole to the span' onClick={() => this.insertPoleToSpan(ohlName, spanName, position)} />
        //             <ClearIcon title='Cancel' alt='Cancel' title='Cancel' onClick={() => this.setState({ showingInfoWindow: false })} />
        //         </span>
        //     </div>;

        this.setState({
            selectedPlace: this.returnAddPoleInforWindow(),
            selectedPlaceName: 'AddPoleToSpan',
            showingInfoWindow: true,
            activeMarker: null,
            infoWindowPosition: position
        })
    }

    insertPoleToSpan = () => {

        const { name, lat, lng, ohlName, spanName } = this.state.poleEdited;

        const ohls = this.state.ohls;
        let updatedOhl = ohls.find(ohl => ohl.name === ohlName);
        if (updatedOhl) {

            const spansList = updatedOhl.rasponi;
            const updatedSpan = spansList.find(s => s.name === spanName);
            const spanIndex = spansList.findIndex(s => s.name === spanName) + 1;

            if (updatedSpan) {
                let previousSpansList = spansList.slice(0, spanIndex);
                let restSpansList = spansList.slice(spanIndex, spansList.length);
                const firstPoleName = updatedSpan.name.substring(0, updatedSpan.name.indexOf(' '));
                const secondPoleName = updatedSpan.name.substring(updatedSpan.name.indexOf(' '), updatedSpan.name.length);

                const newSpanName = name.concat(secondPoleName);
                const newSpan = { name: newSpanName, position: [{ lat: lat, lng: lng }, updatedSpan.position[1]] };
                previousSpansList.push(newSpan);

                updatedSpan.position[1] = { lat: lat, lng: lng };
                updatedSpan.name = firstPoleName.concat(' - ', name);
                updatedOhl.rasponi = previousSpansList.concat(restSpansList);

                const polesList = updatedOhl.stubovi;

                if (polesList) {
                    const firstPoleItemIndex = polesList.findIndex(p => p.name === firstPoleName);

                    if (firstPoleItemIndex) {
                        let previousPolesList = polesList.slice(0, firstPoleItemIndex + 1);
                        previousPolesList.push({ index: firstPoleItemIndex + 2, name: name, lat: lat, lng: lng, sys: 1 });
                        const restPolesList = polesList.slice(firstPoleItemIndex + 1, polesList.length);

                        restPolesList.forEach(pole => {
                            pole.index += 1;
                        });

                        updatedOhl.stubovi = previousPolesList.concat(restPolesList);
                    }
                }
            }
        }

        this.setState({
            showingInfoWindow: false,
            ohls: ohls,
            isOhlListEdited: true
        });
    }

    setMapAsEdited = () => {
        if (this.state.isOhlListEdited) {
            this.setState({
                isOhlListEdited: false
            });
        }
    }

    changePole = (e) => {

        const { value, id } = e.target;
        if (value && id) {
            let poleEdited = Object.assign({}, this.state.poleEdited);
            poleEdited[id] = value;

            this.setState({
                poleEdited: poleEdited,
                //showingInfoWindow: true,
                selectedPlaceName: 'ChangePole' + Math.random(),
                selectedPlace: this.returnAddPoleInforWindow()
            });
        }
    }

    returnAddPoleInforWindow = () => {
        const k = <div style={{ 'lineHeight': '20px' }}>
            <Form>
                <Form.Group controlid="formGroupName">
                    <Form.Control type="text" placeholder="Pole Name" id='name' controlid='name' value={this.state.poleEdited.name} onChange={this.changePole} />
                </Form.Group>
                <Form.Group controlId="formGroupLatitude">
                    <Form.Control type="text" value={this.state.poleEdited.lat} id='lat' controlid='lat' onChange={this.changePole} placeholder="Latitude" />
                </Form.Group>
                <Form.Group controlId="formGroupLongitude">
                    <Form.Control type="text" value={this.state.poleEdited.lng} id='lng' controlid='lng' onChange={this.changePole} placeholder="Longitude" />
                </Form.Group>
            </Form>
            <span /*onClick={() => this.onZoomThirdLevel(props.map, props.position)}*/ style={{ cursor: 'pointer' }}>
                {/* <img src={CheckIcon} title='Add Pole' alt='Add Pole' /> */}
                <CheckIcon title='Add pole to the spa' alt='AddPole' onClick={() => this.insertPoleToSpan()} />
                <ClearIcon title='Cancel' alt='Cancel' onClick={() => this.setState({ showingInfoWindow: false })} />
            </span>
        </div>;

        return k;
    }

    onPhaseClick = (props, map, e) => {

        if (props.path && props.path.length > 0) {

            const position = this.getCurrentPosition(e);
            let spanElement =
                <div>
                    <b><u>Phase: </u> </b> {props.name}<br />
                    <div><b>Position:</b> {props.position} </div>
                    <div><b>OHL:</b> {props.ohlName} </div>
                    <div><b>Span:</b> {props.spanName} </div>
                    <span onClick={() => this.centerOHLByName(props.ohlName)} style={{ marginRight: '25px', marginTop: '15px', cursor: 'pointer' }} ><img src={centerOhlIcon} title='Center OHL' alt='Center OHL' /> </span>
                </div>;

            this.setState({
                selectedPlace: spanElement,
                selectedPlaceName: 'Phase' + props.ohlName + props.name,
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: position
            })
        }
    }

    onWireClick = (props, map, e) => {
        if (props.path && props.path.length > 0) {

            const position = this.getCurrentPosition(e);
            let spanElement =
                <div style={{ 'lineHeight': '20px' }}>
                    <b><u>Protection wire</u></b>  <br />
                    <div><b>Type:</b>  {props.wireType} </div>
                    <div><b>OHL:</b>  {props.ohlName} </div>
                    <div><b>Span:</b>  {props.spanName} </div>
                </div>;

            this.setState({
                selectedPlace: spanElement,
                selectedPlaceName: 'Wire' + props.ohlName + props.spanName,
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: position
            })
        }
    }

    onStationClick = (props, marker) => {
        let selectedPlaceElement =
            <div style={{ 'lineHeight': '20px' }}>
                <div><u><b>Station </b> </u></div>
                <div><b>Name: </b> {props.name} </div>
                <span onClick={() => this.onZoomThirdLevel(props.position)} style={{ cursor: 'pointer' }}> <img src={searchIcon} title='Zoom station' alt='Zoom station' /></span>
                <span onClick={() => this.markStationOhls(props.name)} style={{ cursor: 'pointer' }}> <img src={markOhlIcon} title='Mark OHLs' alt='Mark OHLs' /></span>
            </div>;

        this.setState({
            selectedPlace: selectedPlaceElement,
            selectedPlaceName: props.name,
            activeMarker: marker,
            showingInfoWindow: true,
        })
    };

    onPhaseCrossClick = (props) => {

        if (props.path && props.path.length > 0) {

            let phaseCrossCenter = FindCenter(props.path[0], props.path[1])

            this.setState({
                selectedPlace: this.getInfowindowsPhaseCrossElement(props.path, props.ohls, props.spanName, props.crosses),
                selectedPlaceName: 'PhaseCross',
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: phaseCrossCenter
            })
        }

        this.reseteSelectLists();
    }

    onOhlThunderHitClick = (props) => {
        let ohlThunderStrikeHitElement =
            <div style={{ 'lineHeight': '20px' }}>
                <b><u>OHL Lightning Strike</u></b> <br />
                <div><b>OHL:</b> {props.ohl} </div>
                <div><b>Time:</b> {props.time} </div>
                <div><b>Pole: </b>{props.pole} </div>
                <span onClick={() => this.onZoomThirdLevel(props.position)} style={{ cursor: 'pointer' }}> <img src={searchIcon} title='Zoom' alt='Zoom' /> </span>
            </div>;

        this.setState({
            selectedPlace: ohlThunderStrikeHitElement,
            showingInfoWindow: true,
            activeMarker: null,
            infoWindowPosition: props.position
        })
    }

    onOutageHitClick = (props) => {
        let ohlThunderStrikeHitElement =
            <div style={{ 'lineHeight': '20px' }}>
                <b><u>Fault location</u></b> <br />
                <div><b>OHL:</b> {props.ohl} </div>
                <div><b>Pole: </b>{props.pole} </div>
                <div><b>Start Time:</b> {props.time} </div>
                <div><b>Nearest station:</b> {props.stationName} </div>
                <div><b>Distance:</b> {props.length.toFixed(2)} km </div>
                <div><b>Work Orderer issued:</b> Yes </div>
                <div><b>Department Responsible:</b> Servis station 1 </div>
                <span onClick={() => this.onZoomThirdLevel(props.position)} style={{ cursor: 'pointer' }}> <img src={searchIcon} title='Zoom' alt='Zoom' /> </span>
            </div>;

        this.setState({
            selectedPlace: ohlThunderStrikeHitElement,
            showingInfoWindow: true,
            activeMarker: null,
            infoWindowPosition: props.position
        })
    }


    onUndergroundObjectClick = (props) => {

        if (props.path && props.path.length > 0) {

            let position = FindCenter(props.path[0], props.path[1]);

            let underlineObjectElement = this.getInfoWindowUndergroundObjectElement(props, false);
            let infoWindowsElement = <div>
                {underlineObjectElement}
                <span onClick={() => this.onZoomSecondLevel(position)} style={{ cursor: 'pointer' }}> <img src={searchIcon} title='Zoom underground object' alt='Zoom underground object' /></span>
            </div>

            this.setState({
                selectedPlace: infoWindowsElement,
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: position
            })
        }
    }

    onPruningClick = (props) => {

        if (props.position) {

            let pruningElement = this.getInfoWindowPruningElement(props);
            let infoWindowElement =
                <span>
                    {pruningElement}
                    <span onClick={() => this.onZoomThirdLevel(props.position)} style={{ cursor: 'pointer' }}> 
                        <img src={searchIcon} title='Zoom vegetation' alt='Zoom vegetation' />
                    </span>
                </span>

            this.setState({
                selectedPlace: infoWindowElement,
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: props.position
            })
        }
    }

    onPruningPlaceClick = (props) => {

        if (props.position) {

            let position = props.contact.position;// FindCenter(props.path[0], props.path[1]);

            let infoWindowElement =
                <span>
                    <div style={{ 'lineHeight': '20px' }}>
                        <div><b>Parcel Nr.:</b> {props.contact.parcelNr} </div>
                        <div><b>Is Private Ownership:</b> {props.contact.isPrivate ? 'Yes' : 'No'} </div>
                        <div><b>Owner:</b> {props.contact.owner} </div>
                        <div><b>Contact:</b> {props.contact.tel} </div>
                        <div><b>Email:</b> {props.contact.email} </div>
                    </div>
                    <span
                        onClick={() => this.onZoomThirdLevel(position)}
                        style={{ cursor: 'pointer', marginTop: '15px' }}>
                        <img src={searchIcon} title='Zoom vegetation' alt='Zoom vegetation' />
                    </span>
                </span>

            this.setState({
                selectedPlace: infoWindowElement,
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: position
            })
        }
    }

    onMapClick = (map, maps, e) => {
        this.clearMap();

        if (this.state.editType === 'pole') {
            const latitude = e.latLng.lat();
            const longitude = e.latLng.lng();
            const newPosition = { lat: latitude, lng: longitude };
            this.changePolePosition(newPosition);
        }
    }

    onRightClick = (map, maps, e) => {

        //let k = document.getElementById("googleMapElement");
        const latitude = e.latLng.lat();
        const longitude = e.latLng.lng();
        const position = { lat: latitude, lng: longitude };

        if (this.state.editObject) {
            //this.changePolePosition(position);
        }
        else {
            let infoWindowElement =
                <span>
                    <div style={{ 'lineHeight': '20px' }}>
                        <div>
                            <span
                                onClick={() => this.onZoomFirstLevelAndCloseInfowindow(position)}
                                style={{ cursor: 'pointer', 'lineHeight': '20px' }}>
                                <img src={searchIcon} height='23' width='23' title='Zoom to OHL level' alt='Zoom to OHL level' />
                            </span>
                        </div>
                        <div>
                            <span
                                onClick={() => this.onZoomSecondLevelAndCloseInfowindow(position)}
                                style={{ cursor: 'pointer', 'lineHeight': '20px' }}>
                                <img src={zoomSpanIcon} height='25' width='25' title='Zoom to span level' alt='Zoom to span level' />
                            </span>
                        </div>
                        <div>
                            <span
                                onClick={() => this.onZoomThirdLevelAndCloseInfowindow(position)}
                                style={{ cursor: 'pointer', 'lineHeight': '20px' }}>
                                <img src={zoomPhasesIcon} height='25' width='25' title='Zoom to phase level' alt='Zoom to phase level' />
                            </span>
                        </div>
                    </div>
                </span>

            this.setState({
                selectedPlace: infoWindowElement,
                showingInfoWindow: true,
                activeMarker: null,
                infoWindowPosition: position
            })
        }
    }

    changePolePosition = (newPosition) => {
        if (this.state.editType === 'pole') {
            const { currentPosition } = this.state.editObject;
            const { lat, lng } = currentPosition;

            let updatedOhlList = this.state.ohls;
            //let updatedCheckedOhlList = this.state.checkedOhls;

            if (updatedOhlList) {
                updatedOhlList.forEach(ohl => {
                    let pole = ohl.stubovi.find(p => p.lat === lat && p.lng === lng);
                    if (pole) {
                        pole.lat = newPosition.lat;
                        pole.lng = newPosition.lng;
                    }

                    let span1 = ohl.rasponi.find(spanFirst => spanFirst.position[0].lat === lat && spanFirst.position[0].lng === lng);
                    if (span1) {
                        span1.position[0].lat = newPosition.lat;
                        span1.position[0].lng = newPosition.lng;
                    }

                    let span2 = ohl.rasponi.find(spanSecond => spanSecond.position[1].lat === lat && spanSecond.position[1].lng === lng);
                    if (span2) {
                        span2.position[1].lat = newPosition.lat;
                        span2.position[1].lng = newPosition.lng;
                    }
                });

                this.setState({
                    ohlList: updatedOhlList,
                    editType: null,
                    editObject: null,
                    isOhlListEdited: true
                })
            }
        }
    }


    markOhl = ohlName => {
        let ohlMarked = this.state.ohls.filter(ohl => ohl.name === ohlName);

        if (ohlMarked && ohlMarked.length > 0 && ohlMarked[0].stubovi) {
            this.setOhlSelected([{ name: ohlName, poles: ohlMarked[0].stubovi }])
        }
    };

    markStationOhls = (stationName) => {
        let resultList = [];

        this.state.checkedOhls.forEach(ohl => {
            ohl.stanice.forEach(ohlStation => {
                if (stationName === ohlStation.name) {
                    resultList = resultList.concat({ name: ohl.name, poles: ohl.stubovi });
                }
            });
        });

        this.setState({
            selectedOHLs: resultList
        })

        this.focusAllOHLs2(resultList);
    }

    selectStationOhls = stationName => {
        if (stationName && stationName.length > 0) {
            let resultList = [];

            this.state.checkedOhls.forEach(checkedOhl => {
                checkedOhl.stanice.forEach(stanica => {
                    if (stanica.name === stationName) {
                        resultList = resultList.concat(checkedOhl);
                    }
                });
            });


            this.setState({
                checkedOhls: resultList
            })
        }
    }

    onShowPoleDetails = (ohlName, poleName, poleIndex, lat, lng, sys, isPortal) => {
        this.setState({
            selectedPolesList: [],
            selectedSpansList: [],
            selectedObject: {
                ohlName: ohlName,
                poleName: poleName,
                poleIndex: poleIndex,
                isPortal: isPortal,
                lat: lat,
                lng: lng,
                sys: sys
            },
            showDetails: 'poleDetails'
        });
    }

    onShowSpanDetails = (name, voltage) => {

        this.setState({
            selectedPolesList: [],
            selectedSpansList: [],
            selectedObject: {
                name: name,
                voltage: voltage
            },
            showDetails: 'spanDetails'
        });
    }

    getCurrentPosition = e => {
        if (e) {
            const latitude = e.latLng.lat();
            const longitude = e.latLng.lng();
            return { lat: latitude, lng: longitude };
        }
    }



    render() {
        let undergroundObjectsList = [];
        let pruningList = [];
        let ohlLightningStrikesList = [];
        let ohlLightningAffectedAreasList = [];

        this.state.checkedOhls.forEach(ohl => {

            if (ohl.undergroundObjects && ohl.undergroundObjects.length > 0) {
                let region = regionList.find(r => r.code === ohl.regionCode).name;
                let undergrounObjects = ohl.undergroundObjects.map(object => ({ region: region, voltage: ohl.voltage, ohl: object.ohl, span: object.span, path: object.path, objects: object.objects }))
                undergroundObjectsList = undergroundObjectsList.concat(undergrounObjects)
            }

            if (ohl.pruningList && ohl.pruningList.length > 0) {
                let region = regionList.find(r => r.code === ohl.regionCode).name;
                let pruning = ohl.pruningList.map(pruning => ({
                    region: region,
                    voltage: ohl.voltage,
                    ohl: ohl.name,
                    span: pruning.name,
                    position: pruning.position,
                    isUrgent: pruning.isUrgent,
                    polygon: pruning.polygon,
                    parcelPolygon: pruning.parcelPolygon,
                    vegetationType: pruning.vegetationType,
                    height: pruning.height,
                    contact: pruning.contact
                }))
                pruningList = pruningList.concat(pruning)
            }

            let ohlThunderStrikes = this.state.ohlThunderStrikesList ? this.state.ohlThunderStrikesList.filter(ts => ts.ohl === ohl.name) : [];
            let ohlLightningAffectedAreas = this.state.affectedOhlRegions ? this.state.affectedOhlRegions.filter(ts => ts.ohl === ohl.name) : [];
            if (ohlThunderStrikes && ohlThunderStrikes.length > 0) {
                ohlLightningStrikesList = ohlLightningStrikesList.concat(ohlThunderStrikes);
            }

            if (ohlLightningAffectedAreas && ohlLightningAffectedAreas.length > 0) {
                ohlLightningAffectedAreasList = ohlLightningAffectedAreasList.concat(ohlLightningAffectedAreas);
            }

        });


        const menuItems = [
            { value: this.state.showOutageLayer, name: 'showOutageLayer', title: 'Outage' },
            { value: this.state.showUndergrounObjectsLayer, name: 'showUndergrounObjectsLayer', title: 'Underground Objects' },
            { value: this.state.showPruningLayer, name: 'showPruningLayer', title: 'Pruning' },

            { value: this.state.showStations, name: 'showStations', title: 'Show Stations' },
            { value: this.state.showPortalsAlways, name: 'showPortalsAlways', title: 'Show Portals Always' },
            { value: this.state.showPortalsOnlyForSelectedOHL, name: 'showPortalsOnlyForSelectedOHL', title: 'Show marked OHL direction' },
            { value: this.state.showCountryBorder, name: 'showCountryBorder', title: 'Show Country Border' },
            { value: this.state.showPhaseCross, name: 'showPhaseCross', title: 'Show Phase Cross' },
            { value: this.state.showLargeIcons, name: 'showLargeIcons', title: 'Show Large Icons' },
            { value: this.state.showDividedSpans, name: 'showDividedSpans', title: 'Show Divided Spans' },

            { value: this.state.showHealthIndexes, name: 'showHealthIndexes', title: 'Show Health Indexes' },
            { value: this.state.showThunderStormEffects, name: 'showThunderStormEffects', title: 'Show Thunder Storm Effects' },
            { value: this.state.showJustOhlThunderHits, name: 'showJustOhlThunderHits', title: 'Show Just Ohl Thunder Hits' },
            { value: this.state.showAffectedOhlSections, name: 'showAffectedOhlSections', title: 'Show Affected Ohl Sections' },
            { value: this.state.showOhlThunderHitIcons, name: 'showOhlThunderHitIcons', title: 'Show Ohl Thunder Hit Icons' },
            { value: this.state.showThunderMap, name: 'showThunderMap', title: 'Show Thunder Map' }
        ];


        let cardList = [
            {
                name: 'Layers',
                icon: layersIcon,
                items: [
                    { value: this.state.showOutageLayer, name: 'showOutageLayer', title: 'Outage' },
                    { value: this.state.showUndergrounObjectsLayer, name: 'showUndergrounObjectsLayer', title: 'Underground Objects' },
                    { value: this.state.showPruningLayer, name: 'showPruningLayer', title: 'Pruning' },
                    { value: this.state.showHealthIndexes, name: 'showHealthIndexes', title: 'Health Indexes' },
                ],
            },
            {
                name: 'Map elements',
                icon: poleBlankIcon,
                items: [
                    { value: this.state.showStations, name: 'showStations', title: 'Show Stations' },
                    { value: this.state.showPortalsAlways, name: 'showPortalsAlways', title: 'Show Portals Always' },
                    { value: this.state.showPortalsOnlyForSelectedOHL, name: 'showPortalsOnlyForSelectedOHL', title: 'Show marked OHL direction' },
                    { value: this.state.showCountryBorder, name: 'showCountryBorder', title: 'Show Country Border' },
                    { value: this.state.showPhaseCross, name: 'showPhaseCross', title: 'Show Phase Cross' },
                    { value: this.state.showLargeIcons, name: 'showLargeIcons', title: 'Show Large Icons' },
                    { value: this.state.showDividedSpans, name: 'showDividedSpans', title: 'Show Divided Spans' },
                ],
            }
        ]

        if (this.state.showOutageLayer) {
            const outageCard =
            {
                name: 'Outage',
                icon: flashIcon,
                items: [
                    //{ value: this.state.showThunderStormEffects, name: 'showThunderStormEffects', title: 'Show Thunder Storm Effects' },
                    { value: this.state.showAllThunderHits, name: 'showAllThunderHits', title: 'Show All Ohl Thunder Hits' },
                    { value: this.state.showAffectedOhlSections, name: 'showAffectedOhlSections', title: 'Show Affected Ohl Sections' },
                    { value: this.state.showOhlThunderHitIcons, name: 'showOhlThunderHitIcons', title: 'Show Ohl Thunder Hit Icons' },
                    { value: this.state.showThunderMap, name: 'showThunderMap', title: 'Show Thunder Map' }
                ]
            }

            cardList = cardList.concat(outageCard);
        }

        if (this.state.showPruningLayer) {
            const pruningCard =
            {
                name: 'Pruning',
                icon: pruningIcon,
                items: [
                    { value: this.state.showAllPrunings, name: 'showAllPrunings', title: 'Show all Prunings' },
                    { value: this.state.showPruningIcons, name: 'showPruningIcons', title: 'Show Icons' },
                    //{ value: this.state.showPruningAreas, name: 'showPruningAreas', title: 'Show Affected Areas' },
                    { value: this.state.showPruningParcels, name: 'showPruningParcels', title: 'Show Affected Parcels' },
                ]
            }

            cardList = cardList.concat(pruningCard);
        }

        return (
            <div>
                <div style={ohlSearchStyle}>
                    <span style={{ marginTop: '15px', marginLeft: '10px' }} ></span>
                    <MainMenu2
                        {...this.state}
                        ohlList={this.state.ohls}//{this.ohlMenuList}
                        onToogleOhlChecked={this.onToogleOhlChecked}
                        onToogleOhlsChecked={this.onToogleOhlsChecked}
                        onToogleCheckAll={this.onToogleCheckAll}
                        centerOHLByName={this.centerOHLByName}
                        parentChecked={this.parentChecked}
                        toogleStateAction={this.toogleState}
                        onOutageHitClick={this.onOutageHitClick}
                        onOhlThunderHitClick={this.onOhlThunderHitClick}
                        undergroundObjectsList={undergroundObjectsList}
                        onUndergroundObjectClick={this.onUndergroundObjectClick}
                        pruningList={this.state.showAllPrunings ? pruningList : pruningList.filter(p => p.isUrgent === true)}
                        onPruningClick={this.onPruningClick}
                        menuItems={menuItems}
                        cardList={cardList}
                        checkAll={this.state.checkAll}
                        simulateThunderStorm={this.state.simulateThunderStorm}
                        toogleSimulateThunderStorm={this.toogleSimulateThunderStorm}
                        focusAllOHLs={this.focusAllOHLs}
                        ohlLightningStrikesList={ohlLightningStrikesList}
                        ohlLightningAffectedAreasList={ohlLightningAffectedAreasList}
                    />
                </div>
                <span style={googleMapStyle}>
                    <GoogleMap
                        {...this.state}
                        ohlList={this.state.checkedOhls}
                        isLoaded={this.state.map ? true : false}
                        ohlThickness={3}
                        setMap={this.setMap}
                        centerOHL={this.centerOHLByName}
                        reseteSelectLists={this.reseteSelectLists}
                        onZoomChanged={this.onZoomChanged}
                        onOhlClick={this.onOhlClick}
                        onSegmentClick={this.onSegmentClick}
                        onPortalClick={this.onPortalClick}
                        onPoleClick={this.onPoleClick}
                        onSpanClick={this.onSpanClick}
                        onPhaseClick={this.onPhaseClick}
                        onWireClick={this.onWireClick}
                        onStationClick={this.onStationClick}
                        onPhaseCrossClick={this.onPhaseCrossClick}
                        onZoomThirdLevel={this.onZoomThirdLevel}
                        onOhlThunderHitClick={this.onOhlThunderHitClick}
                        onOutageHitClick={this.onOutageHitClick}
                        undergroundObjectsList={undergroundObjectsList}
                        onUndergroundObjectClick={this.onUndergroundObjectClick}
                        onPruningClick={this.onPruningClick}
                        onPruningPlaceClick={this.onPruningPlaceClick}
                        onRightClick={this.onRightClick}
                        onMapClick={this.onMapClick}

                        pruningList={this.state.showAllPrunings ? pruningList : pruningList.filter(p => p.isUrgent === true)}
                        ohlLightningStrikesList={ohlLightningStrikesList}
                        ohlLightningAffectedAreasList={ohlLightningAffectedAreasList}
                        isOhlListEdited={this.state.isOhlListEdited}
                        setMapAsEdited={this.setMapAsEdited}

                    />
                </span>

                <Drawer isOpen={this.state.showDetails !== null} style={ohlSearchStyle2} >
                    {this.state.showDetails === 'poleDetails' ? <PoleDetails pole={this.state.selectedObject} />
                        : this.state.showDetails === 'spanDetails' ? <SpanDetails span={this.state.selectedObject} />
                            : this.state.showDetails === 'ohlSpans' ? <SpanList spansList={this.state.selectedSpansList} onZoomSpan={this.onZoomSpan} centerOHL={this.centerOHLByName} testOHL={this.testOHL} selectedOHL={this.state.selectedOHLs[0]} />
                                : this.state.showDetails === 'ohlPoles' ? <PolesList polesList={this.state.selectedPolesList} onZoomPole={this.onZoomPole} centerOHL={this.centerOHLByName} selectedOHL={this.state.selectedOHLs[0]} />
                                    : null
                    }
                </Drawer>
            </div>
        )
    }
}

export default GoogleMapContainer;